/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingStateEnum = 'STARTED' | 'STOPPED' | 'STOPPING';

export const BillingStateEnum = {

    STARTED: 'STARTED' as BillingStateEnum,

    STOPPED: 'STOPPED' as BillingStateEnum,

    STOPPING: 'STOPPING' as BillingStateEnum
};

